import React from 'react';
import './sideMenu.css';
import { NavLink } from 'react-router-dom';
import { IonIcon } from '@ionic/react';
import {
  homeOutline,
  briefcaseOutline,
  documentOutline,
  clipboardOutline,
  logOutOutline,
  libraryOutline,
  gridOutline,
  helpOutline,
  logoReact as logoelectron,
  chevronDownOutline,
  chevronForwardOutline,
  layersOutline,
  albumsOutline,
} from 'ionicons/icons';

import * as Icons from 'ionicons/icons';
import logo from '../../assets/images/logo_1.jpg';


class SideMenu extends React.Component {
  constructor() {
    super();
    this.state = {
      openDropdown: null
    };
  }

  toggleDropdown = (groupName) => {
    this.setState((prevState) => ({
      openDropdown: prevState.openDropdown === groupName ? null : groupName,
    }));
  };



  
getSideMenuList() {
  const userCredentials = JSON.parse(sessionStorage.getItem("userCredentials")); // will throw if null or invalid
  const sideMenuList = userCredentials["side_menu"];

  return (
    <div>
      {sideMenuList.map(item => (
        <NavLink
          to={item.sideMenu}
          key={item.id}
          style={({ isActive }) =>
            isActive
              ? { color: '#ffffff', background: '#ff0000' }
              : { textDecoration: 'none' }
          }
        >
          <li>
            <div>
              <span className="icon">
                <IonIcon icon={item.iconName} />
              </span>
              <span className="title">{item.name}</span>
            </div>
          </li>
        </NavLink>
      ))}
    </div>
  );
}


getGroupedSideMenu() {
  const userCredentials = JSON.parse(sessionStorage.getItem("userCredentials"));
  const sideMenuRaw = userCredentials["side_menu"];
  console.log("userCredentials",userCredentials)
  const selectedEntity = userCredentials["selectedentity"]; // or wherever you store it

  // Filter by entity_id first
  const filteredMenu = sideMenuRaw.filter(menuGroup => menuGroup.entity_id === selectedEntity);

  // Map to your grouped menu structure
  const groupedMenu = filteredMenu.map((menuGroup, index) => {
    const processName = menuGroup.process;
    const entityId = menuGroup.entity_id;
    const pages = menuGroup.pages;

    const items = pages.map((page, idx) => ({
      name: page.name,
      iconName: page.iconName,
      sideMenu: page.sideMenu,
      id: `${processName}-${idx}`,
      entity_id: entityId,
    }));

    return {
      groupName: processName,
      items,
      entity_id: entityId,
    };
  });

  return groupedMenu;
}

  render() {
    const { openDropdown } = this.state;

    return (
      <div className="side-menu-navigation">
        <ul>
          <nav>
            {/* App logo */}
            <li>
              <div className="icona">
                <span className="icon">
  <img src={logo} alt="ABS Logo" className="menu-logo" />
</span>
                <span className="title">ABS</span>
              </div>
            </li>

            {/* Landing Page */}
            <NavLink
              to="landing_page"
              style={({ isActive }) =>
                isActive
                  ? { color: '#ffffff', background: '#ff0000' }
                  : { textDecoration: 'none' }
              }
            >
              <li>
                <div>
                  <span className="icon">
                    <IonIcon icon={homeOutline} />
                  </span>
                  <span className="title">Landing Page</span>
                </div>
              </li>
            </NavLink>

            {/* Dynamic Dropdown Groups */}
{this.getGroupedSideMenu().map(({ groupName, items }, index) => (
  <li className={`dropdown ${openDropdown === groupName ? 'open' : ''}`} key={index}>
    <div className="dropdown-title" onClick={() => this.toggleDropdown(groupName)}>
      <span className="icon">
        <IonIcon icon={layersOutline} />
      </span>
      <span className="title">{groupName}</span>
      <span className="dropdown-arrow">
        <IonIcon icon={openDropdown === groupName ? chevronDownOutline : chevronForwardOutline} />
      </span>
    </div>

    {openDropdown === groupName && (
      <ul className="dropdown-content">
        {items.map((item) => (
          <NavLink
            to={item.name}
            key={item.id}
            style={({ isActive }) =>
              isActive
                ? { color: '#ffffff', background: '#ff0000' }
                : { textDecoration: 'none' }
            }
          >
            <li>
              <div>
                <span className="icon">
                  <IonIcon icon={Icons[item.iconName]} />
                </span>
                <span className="title">{item.sideMenu}</span>
              </div>
            </li>
          </NavLink>
        ))}
      </ul>
    )}
  </li>
))}

            {/* Help */}
            <NavLink
              to="Help"
              style={({ isActive }) =>
                isActive
                  ? { color: '#ffffff', background: '#ff0000' }
                  : { textDecoration: 'none' }
              }
            >
              <li>
                <div>
                  <span className="icon">
                    <IonIcon icon={helpOutline} />
                  </span>
                  <span className="title">Help</span>
                </div>
              </li>
            </NavLink>

            {/* Sign Out */}
            <NavLink
              to="/"
              style={({ isActive }) =>
                isActive
                  ? { color: '#ffffff', background: '#ff0000' }
                  : { textDecoration: 'none' }
              }
            >
              <li>
                <div>
                  <span className="icon">
                    <IonIcon icon={logOutOutline} />
                  </span>
                  <span className="title signout">Sign Out</span>
                </div>
              </li>
            </NavLink>
          </nav>
        </ul>
      </div>
    );
  }
}

export default SideMenu;
